import AnimatedSection from './AnimatedSection';

const PartnersSection = () => {
  const partners = [
    {
      name: 'Shopee',
      logo: 'https://res.cloudinary.com/dcu6hlupu/image/upload/w_150,f_auto,q_auto/v1774552345/carvalho-deals/brand/shopee-logo.png',
      color: 'bg-orange-50',
    },
    {
      name: 'Mercado Livre',
      logo: 'https://res.cloudinary.com/dcu6hlupu/image/upload/w_150,f_auto,q_auto/v1774552346/carvalho-deals/brand/mercadolivre-logo.png',
      color: 'bg-yellow-50',
    },
    {
      name: 'Amazon',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg',
      color: 'bg-slate-50',
    },
    {
      name: 'Temu',
      logo: 'https://res.cloudinary.com/dcu6hlupu/image/upload/w_150,f_auto,q_auto/v1774552346/carvalho-deals/brand/temu-logo.png',
      color: 'bg-orange-50',
    },
    {
      name: 'Shein',
      logo: null,
      color: 'bg-slate-50',
      textLogo: true,
      textStyle: 'text-2xl font-black tracking-wider text-black',
    },
    {
      name: 'Hotmart',
      logo: null,
      color: 'bg-orange-50',
      textLogo: true,
      textStyle: 'text-2xl font-black tracking-wide text-[#F04E23]',
    },
  ];

  return (
    <AnimatedSection>
      <section id="parceiros" className="py-16 md:py-20 bg-white">
        <div className="container mx-auto px-4 max-w-7xl">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-slate-900 mb-3">
              Parceiros de Confianca
            </h2>
            <p className="text-slate-600 text-base">
              Trabalhamos com as maiores plataformas do Brasil e do mundo
            </p>
          </div>

          <div className="grid grid-cols-3 md:grid-cols-6 gap-8 items-center justify-items-center">
            {partners.map((partner) => (
              <div
                key={partner.name}
                className="bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow w-full h-24 flex items-center justify-center"
              >
                {partner.textLogo ? (
                  <span className={partner.textStyle}>{partner.name}</span>
                ) : (
                  <img
                    src={partner.logo}
                    alt={partner.name}
                    className="max-h-14 max-w-full object-contain"
                    loading="lazy"
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </AnimatedSection>
  );
};

export default PartnersSection;
